// extracted by mini-css-extract-plugin
export default {"error":"Toast_error__82-A9","success":"Toast_success__H6LoY"};